module.exports = __webpack_public_path__ + "img/menu.3a2e3c5b.svg";